"use client"

import { useState } from "react"
import { Loader2, MailCheck } from "lucide-react"
import { mintaResetPassword } from "@/modules/akun/actions/auth-actions"
import { useCaptcha } from "@/modules/captcha/hooks/use-captcha"
import { CaptchaField } from "@/modules/captcha/ui/captcha-field"
import { KolomTeks, PesanGalat } from "@/modules/akun/ui/kolom"

export function FormLupaPassword() {
  const captcha = useCaptcha()
  const [email, setEmail] = useState("")
  const [terkirim, setTerkirim] = useState(false)
  const [memproses, setMemproses] = useState(false)
  const [galat, setGalat] = useState<string | null>(null)

  const kirim = async () => {
    if (memproses) return
    setGalat(null)
    setMemproses(true)
    const hasil = await mintaResetPassword({ email, tokenCaptcha: captcha.token ?? undefined })
    setMemproses(false)
    captcha.reset()

    if (!hasil.ok) {
      setGalat(hasil.pesan)
      return
    }
    setTerkirim(true)
  }

  if (terkirim) {
    return (
      <div className="space-y-3 text-center">
        <span className="mx-auto grid h-14 w-14 place-items-center rounded-full bg-success/15 text-success">
          <MailCheck className="h-7 w-7" />
        </span>
        <p className="font-display text-lg font-semibold text-foreground">Cek email kamu</p>
        <p className="text-sm text-muted-foreground">Kalau email ini terdaftar, tautan untuk membuat password baru sudah dikirim dan berlaku 60 menit.</p>
      </div>
    )
  }

  return (
    <form
      className="space-y-4"
      onSubmit={(event) => {
        event.preventDefault()
        kirim()
      }}
    >
      <KolomTeks label="Email" type="email" value={email} onChange={setEmail} autoComplete="email" inputMode="email" placeholder="nama@email.com" disabled={memproses} required />
      <CaptchaField captcha={captcha} />
      <PesanGalat pesan={galat} />
      <button type="submit" disabled={memproses || captcha.perluDiselesaikan || email.trim().length < 5} className="btn-primary w-full">
        {memproses ? <Loader2 className="h-4 w-4 animate-spin" /> : "Kirim tautan"}
      </button>
    </form>
  )
}
